import React from 'react';
import clsx from 'clsx';
import { Info } from 'lucide-react';
import styles from './InfoBanner.module.css';

export interface InfoBannerProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  title?: React.ReactNode;
  children: React.ReactNode;
}

const InfoBanner: React.FC<InfoBannerProps> = ({
  title,
  children,
  className,
  ...props
}) => {
  return (
    <div role="note" className={clsx(styles.infoBanner, className)} {...props}>
      <Info size={20} aria-hidden="true" data-test-id="info-banner-icon" />
      <div className={styles.content}>
        {title && <p className={styles.title}>{title}</p>}
        <p className={styles.body}>{children}</p>
      </div>
    </div>
  );
};

export default InfoBanner;
